import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";
import MathUtil from "@/util/MathUtil";

class SoftpayService {
    createAmountForRefund(amount){
        let amountForRefund = MathUtil.displayTwoDecimals(amount).replace(',', ''); //Just remove comma
        return parseInt(amountForRefund);
    }
    refund(transactionId, refundAmount, refundedPayments, refundedCartItems, refundedTipsAmount, orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/payment/softpayRefund';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant,
                transactionId: transactionId,
                amount: this.createAmountForRefund(refundAmount),
                refundedPayments: refundedPayments,
                cartItems: refundedCartItems,
                refundedTipsAmount : refundedTipsAmount,
                orderDocumentId: orderDocumentId
            },
            {headers: basicAuth });
    }
}

export default new SoftpayService();
